<template>
    <div v-if="mobile_app_download == false" id="app">

        <component :is="layout">
            <router-view />
        </component>

        <div class="alert" :class="onboard ? 'onboard-alert' : ''" v-if="messages.length > 0">
            <div
                v-for="(alert, i) of messages" 
                :key="i"
                :class="alert.class"
                :style="alert.icon ? '' : 'justify-content: center;'"
            >
                <div class="alert-message__icon" v-if="alert.icon">
                    <div :class="alert.text == $t('app.alert.synced') ? 'loader stop' : 'loader'"></div>
                </div>
                <div class="alert-message__text">
                    {{renderAlertText(alert.text)}}
                    <a v-if="alert.redirect" href="#" @click="redirectMessage($event, alert)">{{ $t('recur.show_now') }}</a>
                    <span v-if="alert.after_text_upgrade" style="margin-left: 4px;">{{alert.after_text_upgrade}}</span>
                    <i v-if="alert.plan" @click="closeAlert(i)" class="el-icon-close"></i>
                </div>
            </div>
        </div>

        <div class="offline-info" v-if="offline">
            <div>
                <h2>{{ $t('app.alert.no_connection') }}</h2>
                <p>{{ $t('app.alert.check_connection') }}</p>
            </div>
        </div>

        <MenuAction />
        <ProjectLists
            :chat_id="chat._id"
            :chat_users="chat ? chat.users : []"
            :project_id="chat.project_id"
        >
        </ProjectLists>
    </div>
    <div v-else-if="mobile_app_download == true" style="width: 100vw;height: 100%;overflow: hidden;">
        <Mobile/>
    </div>
    <div v-else></div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex"
    import AuthLayout from "@/layouts/AuthLayout"
    import AuthTokenLayout from "@/layouts/AuthTokenLayout"
    import MainLayout from "@/layouts/MainLayout"
    import OnboardLayout from "@/layouts/OnboardLayout"
    import ImportLayout from "@/layouts/ImportLayout"
    import VerificationLayout from "@/layouts/VerificationLayout"
    import NewPasswordLayout from "@/layouts/NewPasswordLayout"
    import ForGotPasswordLayout from "@/layouts/ForGotPasswordLayout"
    import { EventEmitter } from './main'
    import { getVersion } from './plugins/AutoReload/utils'
    import MenuAction from '@/components/comment/MenuAction.vue'
    import ProjectLists from "./components/chats/ProjectLists.vue"
    import Mobile from "./components/app/Mobile.vue"

    export default {
        name: "App",
        data() {
            return {
                onboard: false,
                offline: false,
                interval: '',
                alerts: [],
                messages: [],
                hasOrderChanged: false,
                firstMount: true,
                chat: {},
                getDataInterval: '',
                fetchController: {abort() {return}},
                mobile_app_download: false,
                enumAlert: {
                    "Team max amount": this.$t("messages.team_max_amount"),
                    "Chats max amount": this.$t("messages.chats_max_amount"),
                    "List max amount": this.$t("messages.list_max_amount"),
                    "You can't add more chats": this.$t("messages.cant_add_more_chats"),
                    "Not enough disk space.": this.$t("messages.not_enough_disk_space"),
                    "This user was deleted": this.$t("messages.user_deleted"),
                    "This task was completed outside its active period, so the due date was not updated. To advance the schedule, complete the task when it becomes active.": this.$t("messages.task_completed_outside_period"),
                    "You can't add more sections to this list.": this.$t("messages.cant_add_more_sections"),
                    "Saved": this.$t("messages.saved"),
                    "You can't add more tasks to this list.": this.$t("messages.cant_add_more_tasks"),
                    "Task moved": this.$t("messages.task_moved"),
                    "has reached their limit for list creation.": this.$t("messages.list_creation_limit_reached"),
                    "Invalid email address": this.$t("messages.invalid_email"),
                    "This email already exists": this.$t("messages.email_exists"),
                    "Password is wrong": this.$t("messages.password_wrong"),
                    "Email sent": this.$t("messages.email_sent"),
                    "Name empty": this.$t("messages.name_empty"),
                    "You can't add more folders.": this.$t("messages.cant_add_more_folders")
                }
            }
        },
        methods: {
            ...mapMutations([
                "clearMessage", 
                "changeCommentLoading",
                "setApplicationStatus"
            ]),
            ...mapActions([
                "check_token",
                "socket_send_firebase_token", 
                "connectSocket", 
                "getData",
                "addChatUnreadMessagesRecievedWhileUpdating",
            ]),
            setClass(e) {
                if (e.new) {
                    return 'alertShow alert-message'
                }
                if (e.remove) {
                    return 'alertHide alert-message'
                }
            },
            renderAlertText(text) {
                if (text.includes("Team max amount")) {
                    const phrase = "Team max amount"
                    const after = text.slice(text.indexOf(phrase) + phrase.length).trim();
                    return this.enumAlert[phrase] + ' ' + after
                }
                if (text.includes("Chats max amount")) {
                    const phrase = "Chats max amount"
                    const after = text.slice(text.indexOf(phrase) + phrase.length).trim();
                    return this.enumAlert[phrase] + ' ' + after
                }
                if (text.includes("List max amount")) {
                    const phrase = "List max amount"
                    const after = text.slice(text.indexOf(phrase) + phrase.length).trim();
                    return this.enumAlert[phrase] + ' ' + after
                }
                if (text.includes("has reached their limit for list creation.")) {
                    const before = text.replace("has reached their limit for list creation.", "").trim()
                    return before + ' ' + this.enumAlert['has reached their limit for list creation.']
                }
                return this.enumAlert[text] ? this.enumAlert[text] : text
            },
            closeAlert(i) {
                this.messages = this.messages.filter((e, index) => index != i)
            },
            redirectMessage($e, alert) {
                console.log($e)
                // $e.target.preventDefault()
                if (alert.redirect == 'recur-add') {
                    this.$root.$emit('openRecur')
                    setTimeout(() => {
                        const element = document.querySelector('.recur-completed_tasks')
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
                    }, 500)
                }
            },
            showMessage(e) {
                if (e.key_message) {
                    const msg = e.message != "" ? e.message : this.$w_alert[e.key_message] ? this.$w_alert[e.key_message].text : ''
                    if (msg) {
                        this.messages.push({
                            icon: '',
                            text: msg,
                            class: 'alertShow alert-message',
                            plan: e.plan ? true : false,
                            after_text_upgrade: e.after_text_upgrade,
                            upgrade_text: e.upgrade_text,
                            redirect: e.redirect
                        })
                        if (e.plan) {
                            setTimeout(() => {
                                this.messages[0].class = 'alertHide alert-message'
                                this.messages.shift()
                            }, 10000)
                        } else {
                            setTimeout(() => {
                                this.messages[0].class = 'alertHide alert-message'
                                this.messages.shift()
                            }, 3500)
                        }
                    }
                } else {
                    if (this.$w_alert["no key_message"]) {
                        const msg = this.$w_alert["no key_message"].text
                        this.messages.push({
                            icon: '',
                            text: msg,
                            class: 'alertShow alert-message',
                            redirect: e.redirect,
                            plan: e.plan ? true : false,
                        })
                        setTimeout(() => {
                            this.messages[0].class = 'alertHide alert-message'
                            this.messages.pop()
                        }, 2000)
                    }
                }
            },
            openSettingPlan(e) {
                e.preventDefault()
                EventEmitter.$emit('openSettingPlan', true)
            },
            async handleGetData() {
                return await this.getData()
                .then((res) => {
                    this.resetSubtaskOpen()
                    this.alerts = this.alerts.filter(
                        (alert) => alert.text !== this.$t('app.alert.syncing')
                    )
                    this.alerts.push({
                        icon: true,
                        text: this.$t('app.alert.synced'),
                        class: "alert-message"
                    })
                    setTimeout(() => {
                        this.addChatUnreadMessagesRecievedWhileUpdating()
                    }, 0)
                    setTimeout(() => {
                        this.alerts = this.alerts.filter(
                            (alert) => alert.text !== this.$t('app.alert.synced')
                        )
                    }, 1000)
                })
                .catch((err) => {
                    console.log('Get Data Error', err)
                    this.$socket.disconnect()
                })
            },
            resetSubtaskOpen() {
                const len = Object.keys(this.getTasks).length
                if (len > 0) {
                    for (let list in this.getTasks) {
                        const currentProject = this.getTasks[list]
                        for (let i = 0; i < currentProject.length; i++) {
                            if (currentProject[i].parent && currentProject[i].unread_message) {
                                localStorage.setItem(currentProject[i].parent, true)
                                EventEmitter.$emit('openSubtask', currentProject[i]._id)
                                i = currentProject.length + 5
                            }
                        }
                    }
                }
            },
            handleSocketDisconnected() {
                this.alerts = [];
                this.alerts.push({
                    icon: true,
                    text: this.$t('app.alert.connecting'),
                    class: "alert-message"
                })
            },
        },
        computed: {
            ...mapGetters([
                "getAppLoader",
                "getTasks",
                "getProjects",
                "getMessage", 
                "getUserData", 
                "getChats", 
                "getCompletedTasks",
                "getChatUnreadMessagesWhileUpdating",
                "getApplicationStatus"
            ]),
            layout() {
                return (this.$route.meta.layout || "auth") + "-layout"
            }
        },
        watch: {
            getMessage(e) {
                if (e && e.key_message != "") this.showMessage(e)
            },
            getAppLoader(e) {
                if (e == false) {
                    setTimeout( async () => {
                        if (localStorage.getItem('new_version')) {
                            let data = await getVersion()
                            if (data.Description) {
                                this.$w_alert_size(data.Description, 560, [
                                    {
                                        buttonText: this.$t('app.alert.close'),
                                        callback: (close) => {
                                            localStorage.removeItem('new_version')
                                            close()
                                        }
                                    }
                                ])
                            }
                        }
                    }, 1000)
                }
            }
        },
        components: {
            AuthLayout,
            MainLayout,
            VerificationLayout,
            NewPasswordLayout,
            ForGotPasswordLayout,
            ImportLayout,
            AuthTokenLayout,
            MenuAction,
            ProjectLists,
            Mobile,
            OnboardLayout
        },
        mounted() {

            this.$root.$on('onboard:alert', (data) => {
                this.onboard = data
            })

            const params = new URLSearchParams(window.location.search)
            const lang = params.get('lang')
            if (!this.getUserData.id) {
                if (lang) {
                    localStorage.setItem('language', lang)
                    this.$i18n.locale = lang
                }
            }

            const savedLanguage = localStorage.getItem('language');
            if (savedLanguage) {
                this.$i18n.locale = savedLanguage;
            }

            setTimeout(() => {
                if (window.isElectronMac == true) {
                    document.body.classList.add('platform_ios')
                }
                if (window.innerWidth <= 1079) {
                    document.head.querySelector("[name~=viewport][content]").content = 'width=device-width,initial-scale=1.0'
                    if (this.$router.history.current.name == 'AuthToken') {
                        this.mobile_app_download = undefined
                    } else {
                        this.mobile_app_download = true
                    }
                }
            }, 500)

            EventEmitter.$on('fetchRequestController', (controller) => this.fetchController = controller)
            EventEmitter.$on('mainLayoutMounted', this.firstMount = true)
            EventEmitter.$on('openProjectsList', chat => this.chat = chat)

            const interval = setInterval(() => {
                const len = Object.keys(this.getTasks).length
                if (len > 0) {
                    for (let list in this.getTasks) {
                        const currentProject = this.getTasks[list]
                        for (let i = 0; i < currentProject.length; i++) {
                            if (currentProject[i].parent && currentProject[i].unread_message) {
                                localStorage.setItem(currentProject[i].parent, true)
                                i = currentProject.length + 5
                            }
                        }
                    }
                    clearInterval(interval)
                }
            }, 1000)
          
            EventEmitter.$on('toggleOrderChanged', (value) => {
                if (this.$socket.disconnected) {
                    this.hasOrderChanged = true
                }
            })

            EventEmitter.$on('taskOrderChangeComplate', async () => {
                if (this.hasOrderChanged) {
                    this.hasOrderChanged = false
                }
            })

            EventEmitter.$on('open_notification_direction', (link = '') => {
                if (link) {
                    this.$router.push(link)
                }
            })

            EventEmitter.$on('openPushNotificationLink', link => {
                if (this.$route.fullPath == link) return
                this.$router.push(link)
            })

            let message_settings = {
                dir: 'ltr',
                lang: 'en-US',
                tag: 'reminder',
                renotify: true
            }

            if (!window.isElectronMac) {
                message_settings.icon = '/logo.png'
                message_settings.badge = '/logo.png'
            }

            if (window.isElectron) {
                message_settings.silent = true
            } else {
                message_settings.vibrate = [ 100, 50, 200 ]
            }
            
            let current_status = 'online'

            setInterval(() => {

                if (window.isElectronMac == true) {
                    document.body.classList.add('platform_ios')
                }

                if (window.isElectron) {
                    if (!document.hasFocus() && document.hidden && current_status == 'online') {
                        current_status = 'offline'
                        this.$socket.emit("IN_LastSeen", "offline")
                    } else if (document.hasFocus() && !document.hidden && current_status != 'online') {
                        window.focusElectron = true
                        current_status = 'online'
                        this.$socket.emit("IN_LastSeen", "online")
                    }
                }

                let date = new Date().getDate()

                EventEmitter.$emit('nowDate', date)

            }, 5000)

        }
    }
</script>
